// extracted by mini-css-extract-plugin
export default {"button":"forgotten_button__rRd5f","container":"forgotten_container__znG0A","title":"forgotten_title__iVDSC","form":"forgotten_form__C2L5J","card":"forgotten_card__HkDWG"};